import { useEffect, useRef, useState } from 'react';
import PhoneInput from '../ShippingLocationsPage/PhoneInput';
import { TabsStyled, TabStyled } from './NewBooking.styled';
import { InputStyled, SelectStyled } from '../Inputs.styled';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { stylesMUIInput } from '../stylesMUIInput';
import { IconButton, MenuItem } from '@mui/material';
import { useStyles } from '../LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles';
import axios from 'axios';
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { TextField } from '@mui/material'
import StopsModal from './Stops/StopsModal';
import { EXPORT_FILING_OPTIONS, DUTY_TAX_OPTIONS, FTR_EXEMPTION_CODES } from '../../constants/dhlExportFilingOptions';
import { UserModel } from '../../modules/auth/models/UserModel';
import { formatPhone } from '../../helpers/formatPhone';

const TRUCKTYPES = '/api/v1/system/trucktype'
const ICONTERMS = 'api/v1/database/incoterms'
const FTR_CODES_ENDPOINT = '/api/v1/database/ftrexemptions'
const GET_SHIPPING_LOCATION = '/api/v1/database/shippinglocation'

const Tabs = ({formik, mode}) => {
    const [tab, setTab] = useState(0)
    const dispatch = useDispatch()
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
    const user = useSelector<RootState>(({auth}) => auth.user) as UserModel
    const brokerAutofillRef = useRef(null)
    const [equipments, setEquipments] = useState([])
    const [openStopsModal, setOpenStopsModal] = useState(false)
    const [incoTermsList, setIncoTermList] = useState([]);
    const [selectedIncoTerms, setSelectedIncoTerms] = useState('');
    const [ftrExemptionCodes, setFtrExemptionCodes] = useState([]);
    const classes = useStyles({
        fontSize: fontSize
    })

    const a11yProps = (index) => {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setTab(newValue);
    }

    const selectInconTerms = (selected) => {
        formik.setFieldValue('otherInfo.incoTerm', selected);        
   }

    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }

    useEffect(() => {
        if(mode?.shipmentCategory === 'Volume'){
            axios.get(TRUCKTYPES).then(results => {
                setEquipments(results.data.data.results)
              }).catch(error => {
                checkErrorAPICall(error, dispatch, 'Get Truck Types')
            })
        }else{
            if(tab === 3){
                setTab(0)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode])

    const getIconTerms = async () => {
        await axios.get(ICONTERMS).then(results => {
            setIncoTermList(results.data.data.results);
        }).catch(error => {
            checkErrorAPICall(error, dispatch, 'Get Inco Terms Error')
        })
    }

    const getFTRExemptionCodes = async () => {
        await axios.get(FTR_CODES_ENDPOINT).then(results => {
            const codes = results.data.data.results;
            if (codes && codes.length > 0) {
                setFtrExemptionCodes(codes.map((item: any) => ({
                    code: item.FTRCode,
                    description: item.description
                })));
            } else {
                setFtrExemptionCodes(FTR_EXEMPTION_CODES);
            }
        }).catch(() => {
            // Fallback to hardcoded codes if endpoint not available
            setFtrExemptionCodes(FTR_EXEMPTION_CODES);
        })
    }


    useEffect(() => {
            getIconTerms()
            getFTRExemptionCodes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {        
        setSelectedIncoTerms(formik.values.otherInfo.incoTerm)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.otherInfo.incoTerm])

    const isUSCountry = (country) => {
        const value = (country || '').toString().toUpperCase()
        return value === 'US' || value === 'USA'
    }
    const isInternationalShipment = !isUSCountry(formik.values.shipper?.country) || !isUSCountry(formik.values.consignee?.country)

    useEffect(() => {
        const billToId = user?.billToInformation?.id || user?.billToInformation?.Id
        const brokerAlreadySet = !!formik.values.otherInfo?.broker?.name?.trim()
        const isExistingDispatched = !!(formik.values.dispatched || (newBookingValues?.dispatched && newBookingValues?.BOLId))

        if (!isInternationalShipment) {
            brokerAutofillRef.current = null
            return
        }
        if (!billToId || isExistingDispatched || brokerAlreadySet) {
            return
        }
        if (brokerAutofillRef.current === billToId) {
            return
        }

        brokerAutofillRef.current = billToId

        axios.get(`${GET_SHIPPING_LOCATION}/${billToId}`).then(result => {
            const data = result?.data?.data
            const shipping = Array.isArray(data?.results) ? data.results[0] : (data?.results || data)
            const brokerInfo = shipping?.brokerInformation
            const hasBrokerData = brokerInfo?.name?.trim() || brokerInfo?.contact?.trim() || brokerInfo?.phone?.trim()

            if (!hasBrokerData) {
                return
            }

            formik.setFieldValue('otherInfo.broker', {
                ...formik.values.otherInfo?.broker,
                name: brokerInfo.name || '',
                contact: brokerInfo.contact || '',
                phone: formatPhone(brokerInfo.phone, 'US') || '',
                instructions: brokerInfo.notes || '',
            })
        }).catch(() => {
            brokerAutofillRef.current = null
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.shipper?.country, formik.values.consignee?.country, formik.values.otherInfo?.broker?.name, formik.values.dispatched, user?.billToInformation?.id, user?.billToInformation?.Id, newBookingValues?.dispatched, newBookingValues?.BOLId])

    return (
        <>
            <TabsStyled value={tab} onChange={handleChange} aria-label="basic tabs example">
                <TabStyled style={{textTransform: 'none'}} disableTouchRipple={true} label="Special Instructions" {...a11yProps(0)} />
                <TabStyled style={{textTransform: 'none'}} disableTouchRipple={true} label="Shipment Notes" {...a11yProps(1)} />
                <TabStyled style={{textTransform: 'none'}} disableTouchRipple={true} label="Other Info" {...a11yProps(2)} />
                {mode?.shipmentCategory === 'Volume' ? <TabStyled style={{textTransform: 'none'}} disableTouchRipple={true} label="Stops" {...a11yProps(3)} /> : null}
            </TabsStyled>
            <div className={`${tab === 0 ? 'd-flex' : 'd-none'} mt-4`}>
                <textarea
                    className="form-control"
                    style={{height: 119}}
                    autoComplete='off'
                    {...formik.getFieldProps('specialInstructions')}
                    disabled={newBookingValues?.dispatched}
                />
            </div>
            <div className={`${tab === 1 ? 'd-flex' : 'd-none'} mt-4`}>
                <textarea
                    className="form-control"
                    style={{height: 119}}
                    autoComplete='off'
                    {...formik.getFieldProps('shipmentNotes')}
                    disabled={newBookingValues?.dispatched}
                />
            </div>
            <div className={`${tab === 2 ? 'd-flex' : 'd-none'} row mt-4`}>
                {
                    isInternationalShipment &&
                    <>
                        <div className="col-3">
                            <label className='col-form-label'>Broker Name</label>
                        </div>
                        <div className="col-9">
                            <input
                                className="form-control"
                                autoComplete='off'
                                {...formik.getFieldProps('otherInfo.broker.name')}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Broker Contact</label>
                        </div>
                        <div className="col-9 mt-4">
                            <input
                                className="form-control"
                                autoComplete='off'
                                {...formik.getFieldProps('otherInfo.broker.contact')}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Broker Phone</label>
                        </div>
                        <div className="col-9 mt-4">
                            <PhoneInput
                                value={formik.values.otherInfo.broker.phone || ""}
                                setDataFormik={formik.setFieldValue}
                                name={'otherInfo.broker.phone'}
                                countryCode={"US"}
                                deleteSelectCountry={true}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        <div className="col-3 mt-4 mb-4">
                            <label className='col-form-label'>Instructions</label>
                        </div>
                        <div className="col-9 mt-4 mb-4">
                            <textarea
                                className="form-control"
                                style={{height: 119}}
                                autoComplete='off'
                                {...formik.getFieldProps('otherInfo.broker.instructions')}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                    </>
                }
                <div className="col-3">
                    <label className='col-form-label'>BKG Ref#</label>
                </div>
                <div className="col-9">
                    <InputStyled
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('otherInfo.BKGRefNumber')}
                        fontSize={fontSize}
                        disabled={newBookingValues?.dispatched}
                    />
                </div>
                <div className="col-3 mt-4">
                    <label className='col-form-label'>BKG Value</label>
                </div>
                <div className="col-9 mt-4">
                    <InputStyled
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('otherInfo.BKGValue')}
                        maxLength={12}
                        fontSize={fontSize}
                        disabled={newBookingValues?.dispatched}
                    />
                </div>
                <div className="col-3 mt-4">
                    <label className='col-form-label'>Ref. #1</label>
                </div>
                <div className="col-9 mt-4">
                    <InputStyled
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('otherInfo.refNumber1')}
                        maxLength="120"
                        fontSize={fontSize}
                        disabled={newBookingValues?.dispatched}
                    />
                </div>
                <div className="col-3 mt-4">
                    <label className='col-form-label'>Ref. #2</label>
                </div>
                <div className="col-9 mt-4">
                    <InputStyled
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('otherInfo.refNumber2')}
                        maxLength="120"
                        fontSize={fontSize}
                        disabled={newBookingValues?.dispatched}
                    />
                </div>
                {incoTermsList && (
                    <>
                    <div className="col-3 mt-4">
                        <label className='col-form-label'>IncoTerms</label>
                    </div>
                    <div className="col-9 mt-4">
                        <TextField
                            select
                            label=" "
                            value={selectedIncoTerms}
                            name={'otherInfo.incoTerm'}
                            onChange={(e) => {
                                selectInconTerms(e.target.value)
                            }}
                            className={`${classes.selectMUI}`}
                            InputProps={{
                                style: stylesMUIInput(fontSize),
                            }}
                            SelectProps={{
                                IconComponent: KeyboardArrowDownIcon,
                                MenuProps: menuProps,
                                multiple: false
                            }}
                            InputLabelProps={{shrink: false}}
                        >
                            {incoTermsList.map((incoTerm, index) => <MenuItem key={index}  value={incoTerm.code}>{incoTerm.name}</MenuItem>)}
                        </TextField>
                    </div>
                    </>
                )}
                {/* DHL Fields - Only for international shipments */}
                {
                    isInternationalShipment &&
                    <>
                        {/* Paperless Trade */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Paperless Trade</label>
                        </div>
                        <div className="col-9 mt-4 d-flex align-items-center">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={formik.values.otherInfo.paperlessTrade || false}
                                onChange={(e) => formik.setFieldValue('otherInfo.paperlessTrade', e.target.checked)}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        {/* Duties Paid */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Duties Paid</label>
                        </div>
                        <div className="col-9 mt-4 d-flex align-items-center">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={formik.values.otherInfo.dutiesPaid || false}
                                onChange={(e) => formik.setFieldValue('otherInfo.dutiesPaid', e.target.checked)}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        {/* ITN Number */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>ITN #</label>
                        </div>
                        <div className="col-9 mt-4">
                            <InputStyled
                                className="form-control"
                                autoComplete='off'
                                placeholder=""
                                {...formik.getFieldProps('otherInfo.itnNumber')}
                                fontSize={fontSize}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                        {/* Duty & Tax Payable By */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Duty & Tax Payable by</label>
                        </div>
                        <div className="col-9 mt-4">
                            <TextField
                                select
                                label=" "
                                value={formik.values.otherInfo.dutyAndTaxPayableBy || ''}
                                name={'otherInfo.dutyAndTaxPayableBy'}
                                onChange={(e) => {
                                    formik.setFieldValue('otherInfo.dutyAndTaxPayableBy', e.target.value)
                                    if (e.target.value !== 'Receiver') {
                                        formik.setFieldValue('otherInfo.receiverAccountNumber', '')
                                    }
                                }}
                                className={`${classes.selectMUI}`}
                                InputProps={{
                                    style: stylesMUIInput(fontSize),
                                }}
                                SelectProps={{
                                    IconComponent: KeyboardArrowDownIcon,
                                    MenuProps: menuProps,
                                    multiple: false
                                }}
                                InputLabelProps={{shrink: false}}
                            >
                                {DUTY_TAX_OPTIONS.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </div>
                        {/* Receiver Account Number - Only when Receiver is selected */}
                        {formik.values.otherInfo.dutyAndTaxPayableBy === 'Receiver' && (
                            <>
                                <div className="col-3 mt-4">
                                    <label className='col-form-label'>Receiver Account #</label>
                                </div>
                                <div className="col-9 mt-4">
                                    <InputStyled
                                        className="form-control"
                                        autoComplete='off'
                                        placeholder=""
                                        {...formik.getFieldProps('otherInfo.receiverAccountNumber')}
                                        fontSize={fontSize}
                                        disabled={newBookingValues?.dispatched}
                                    />
                                </div>
                            </>
                        )}
                        {/* Export Filing */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>Export Filing</label>
                        </div>
                        <div className="col-9 mt-4">
                            <TextField
                                select
                                label=" "
                                value={formik.values.otherInfo.exportFiling || ''}
                                name={'otherInfo.exportFiling'}
                                onChange={(e) => {
                                    formik.setFieldValue('otherInfo.exportFiling', e.target.value)
                                    if (e.target.value !== 'FTR') {
                                        formik.setFieldValue('otherInfo.ftrExemptionCode', '')
                                    }
                                    if (e.target.value !== 'ITN') {
                                        formik.setFieldValue('otherInfo.itnNumber', '')
                                    }
                                }}
                                className={`${classes.selectMUI}`}
                                InputProps={{
                                    style: stylesMUIInput(fontSize),
                                }}
                                SelectProps={{
                                    IconComponent: KeyboardArrowDownIcon,
                                    MenuProps: menuProps,
                                    multiple: false
                                }}
                                InputLabelProps={{shrink: false}}
                            >
                                {EXPORT_FILING_OPTIONS.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </div>
                        {/* FTR Exemption Code - Only when FTR is selected */}
                        {formik.values.otherInfo.exportFiling === 'FTR' && (
                            <>
                                <div className="col-3 mt-4">
                                    <label className='col-form-label'>FTR Exemption</label>
                                </div>
                                <div className="col-9 mt-4">
                                    <TextField
                                        select
                                        label=" "
                                        value={formik.values.otherInfo.ftrExemptionCode || ''}
                                        name={'otherInfo.ftrExemptionCode'}
                                        onChange={(e) => {
                                            formik.setFieldValue('otherInfo.ftrExemptionCode', e.target.value)
                                        }}
                                        className={`${classes.selectMUI}`}
                                        InputProps={{
                                            style: stylesMUIInput(fontSize),
                                        }}
                                        SelectProps={{
                                            IconComponent: KeyboardArrowDownIcon,
                                            MenuProps: {
                                                ...menuProps,
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 300,
                                                        maxWidth: 500,
                                                    }
                                                }
                                            },
                                            multiple: false
                                        }}
                                        InputLabelProps={{shrink: false}}
                                    >
                                        {ftrExemptionCodes.map((exemption, index) => (
                                            <MenuItem key={index} value={exemption.code} style={{ whiteSpace: 'normal', fontSize: '13px', lineHeight: '1.3', padding: '8px 16px' }}>
                                                <span><strong>{exemption.code}</strong> - {exemption.description}</span>
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </>
                        )}
                        {/* DHL Notification Email */}
                        <div className="col-3 mt-4">
                            <label className='col-form-label'>DHL Notification Email</label>
                        </div>
                        <div className="col-9 mt-4">
                            <InputStyled
                                className="form-control"
                                autoComplete='off'
                                type="email"
                                placeholder=""
                                {...formik.getFieldProps('otherInfo.dhlNotificationEmail')}
                                fontSize={fontSize}
                                disabled={newBookingValues?.dispatched}
                            />
                        </div>
                    </>
                }
            </div>
            <div className={`${tab === 3 ? 'd-flex' : 'd-none'} row mt-4`}>
                <div className="col-12 col-sm-2">
                    <label className='col-form-label'>Service type</label>
                </div>
                <div className="col-12 col-sm-5">
                    <SelectStyled
                        value={formik.values?.stops?.serviceType ? formik.values?.stops?.serviceType : 'EXCLUSIVE'}
                        name='stops.serviceType'
                        onChange={formik.handleChange} 
                        className={classes.select}
                        displayEmpty={true}
                        inputProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps,
                            style: stylesMUIInput(fontSize),
                        }}
                        style={{
                            color: '#5E6278',
                        }}
                        fontSize={fontSize}
                    >
                        {
                            ['EXCLUSIVE', 'PARTIAL']?.map((stack, index) => {
                                return <MenuItem key={index} value={stack}>{stack === 'EXCLUSIVE' ? 'Exclusive' : 'Partial'}</MenuItem>
                            })
                        }
                    </SelectStyled>
                </div>
                <div className="col-12 col-sm-2">
                    <label className='col-form-label'>Stops</label>
                </div>
                <div className="col-12 col-sm-3 d-flex align-items-center">
                    <InputStyled
                        className="form-control me-1"
                        readOnly={true}
                        autoComplete='off'
                        value={formik.values?.stops?.stops?.length || ''}
                        disabled={newBookingValues?.dispatched}
                        fontSize={fontSize}
                    />
                    <div>
                        <IconButton onClick={() => setOpenStopsModal(true)}>
                            <AccessTimeIcon/>
                        </IconButton>
                    </div>
                </div>

                {/* //////////////////////////////////////////////////// */}

                <div className="col-12 col-sm-2 mt-0 mt-sm-4">
                    <label className='col-form-label'>Equipment</label>
                </div>
                <div className="col-12 col-sm-5 mt-0 mt-sm-4">
                    <TextField
                        select
                        label=" "
                        value={formik.values?.stops?.equipment ? formik.values?.stops?.equipment : []}
                        name='stops.equipment'
                        onChange={formik.handleChange}
                        className={classes.selectMUI}
                        InputProps={{
                            style: stylesMUIInput(fontSize),
                        }}
                        SelectProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps,
                            multiple: true
                        }}
                        InputLabelProps={{shrink: false}}
                    >
                        {
                            equipments?.map((equipment, index) => {
                                return <MenuItem key={index} value={equipment.id}>{equipment.name}</MenuItem>
                            })
                        }
                    </TextField>
                </div>
                <div className="col-12 col-sm-2 mt-0 mt-sm-4">
                    <label className='col-form-label'>Length</label>
                </div>
                <div className="col-12 col-sm-3 d-flex align-items-center mt-0 mt-sm-4">
                    <InputStyled
                        type="number"
                        className="form-control me-4"
                        autoComplete='off'
                        {...formik.getFieldProps('stops.length')}
                        disabled={newBookingValues?.dispatched}
                        fontSize={fontSize}
                    />
                    <div className="me-4">ft.</div>
                </div>
            </div>
            <StopsModal
                open={openStopsModal}
                setOpen={setOpenStopsModal}
                formik={formik}
            />
        </>
    )
}

export default Tabs